























































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import { FETCH_SEARCH_PRODUCT_LIST } from '@/store/action-types'
import { ProductSearchRequest } from '@/types/payload'
import { ProductSearchResponse } from '@/types/service-response'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'

interface ComponentData {
  loading: boolean
  productList: ProductSearchResult[]

  schluessel: string
  bezeichnung: string
  lagercode: string
  gruppe: string
  barcode: string
  klProduktivNr: string
  verfuegbar: boolean
  nurBevorzugteLager: boolean
  nurAuslierfortSyzSRO: boolean
  gesperrteAusblenden: boolean
  verfuegbarReservationen: boolean
  verfuegbarBestellungen: boolean
  check1: boolean
  check2: boolean
}

export default Vue.extend({
  name: 'ProductSearch',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    searchString: String,
    foundList: Array as () => ProductSearchResult[]
  },

  data (): ComponentData {
    return {
      loading: false,
      productList: [],

      schluessel: '',
      bezeichnung: '',
      lagercode: '',
      gruppe: '',
      barcode: '',
      klProduktivNr: '',
      verfuegbar: false,
      nurBevorzugteLager: false,
      nurAuslierfortSyzSRO: false,
      gesperrteAusblenden: false,
      verfuegbarReservationen: false,
      verfuegbarBestellungen: false,
      check1: true,
      check2: true
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    rowDblClick (event: any): void {
      this.$emit('selectedProduct', event.data)
    },

    onSearchButtonClick (): void {
      this.searchProduct()
    },

    async searchProduct (): Promise<void> {
      const payload: ProductSearchRequest = {
        Schluessel: this.schluessel,
        Bezeichnung: this.bezeichnung,
        Lagercode: this.lagercode,
        Gruppe: this.gruppe,
        Barcode: this.barcode,
        KlProduktivNr: this.klProduktivNr,
        Verfuegbar: this.verfuegbar,
        NurBevorzugteLager: this.nurBevorzugteLager,
        NurAuslierfortSyzSRO: this.nurAuslierfortSyzSRO,
        GesperrteAusblenden: this.gesperrteAusblenden,
        VerfuegbarReservationen: this.verfuegbarReservationen,
        VerfuegbarBestellungen: this.verfuegbarBestellungen,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId
      }

      try {
        this.loading = true
        const response: ProductSearchResponse = await this.$store.dispatch(FETCH_SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchResult.createFromResponse(response.Results)
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    }
  },

  mounted (): void {
    this.schluessel = this.searchString ? this.searchString : ''
    this.productList = this.foundList ? this.foundList : []
  }
})
